<template>
	<div>
		<div
			class="list-selection-wrapper"
			:class="{ loading, 'hide-center': hideCenter }"
		>
			<slot name="left" :on="listeners('left')" :value="selected.left">
				<list-box
					:value="selected.left"
					:icon="icon"
					:subheader="title"
					:items="_leftItems"
					v-bind="leftProps"
					@select="handleSelect('left', $event)"
				/>
			</slot>
			<div v-if="!hideCenter" class="centralize">
				<slot name="buttons">
					<v-btn
						class="selection-btn"
						icon
						:loading="!!selected.left.length && loading"
						:disabled="disabled || !selected.left.length"
						@click="add"
						><v-icon>fa-arrow-right</v-icon></v-btn
					>
					<v-btn
						class="selection-btn"
						icon
						:loading="!!selected.right.length && loading"
						:disabled="disabled || !selected.right.length"
						@click="remove"
						><v-icon>fa-arrow-left</v-icon></v-btn
					>
				</slot>
			</div>
			<slot name="right" :on="listeners('right')" :value="selected.right">
				<list-box
					:value="selected.right"
					:header-icon="icon"
					:header="title"
					:items="rightCopy"
					v-bind="rightProps"
					@select="handleSelect('right', $event)"
				/>
			</slot>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import ListBox from "./ListBox";

export default {
	components: {
		ListBox,
	},

	props: {
		leftItems: {
			type: Array,
		},
		rightItems: {
			type: Array,
		},
		title: String,
		icon: String,
		hideCenter: Boolean,
		addItem: {
			type: Function,
			default: () => () => {},
		},
		removeItem: {
			type: Function,
			default: () => () => {},
		},
		inclusive: Boolean,
		disabled: Boolean,
		leftProps: {
			type: Object,
			default: () => ({}),
		},
		rightProps: {
			type: Object,
			default: () => ({}),
		},
	},

	data() {
		return {
			loading: false,
			selected: {
				left: [],
				right: [],
			},
			rightCopy: [],
		};
	},

	computed: {
		_leftItems() {
			if (this.inclusive) return this.leftItems;
			return _.differenceBy(this.leftItems, this.rightCopy, (item) => item.id || item._id);
		},
	},

	watch: {
		"selected.right"(val = []) {
			if (val.length) this.selected.left = [];
		},
		"selected.left"(val = []) {
			if (val.length) this.selected.right = [];
		},
		rightItems(val = []) {
			this.rightCopy = val;
		},
	},

	created() {
		this.rightCopy = this.rightItems;
	},

	methods: {
		async add() {
			this.loading = true;

			await this.addItem(_.map(this.selected.left, (item) => item.id || item._id));

			// const added = [...this.rightCopy, ...this.selected.left];
			// this.rightCopy = [...new Set(added)];

			this.resetItemsIcon(this.selected.left);
			this.selected.left = [];
			this.loading = false;
		},

		async remove() {
			this.loading = true;

			await this.removeItem(_.map(this.selected.right, (item) => item.id || item._id));

			// this.rightCopy = _.differenceBy(
			// 	this.rightCopy,
			// 	this.selected.right,
			// 	"id"
			// );

			this.resetItemsIcon(this.selected.right);
			this.selected.right = [];
			this.loading = false;
		},

		resetItemsIcon(items) {
			items.forEach((item) => {
				item.icon = "";
			});
		},

		setItemsLoading(items, loading = true) {
			this.loading = loading;
		},

		handleSelect(type, item) {
			this.selected[type] = item;
		},

		shouldAdd() {
			if (!this.selected) return;
			return !~this.rightItems.findIndex(
				(item) => item.id === this.selected.id
			);
		},

		listeners(type) {
			return {
				select: (item) => {
					this.selected[type] = item;
				},
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.list-selection-wrapper {
	display: grid;
	grid-template-columns: 1fr 50px 1fr;
	height: inherit;
	max-height: inherit;

	.list-box-wrapper {
		height: inherit;
		max-height: inherit;
	}

	&.hide-center {
		grid-template-columns: 1fr 1fr;
		gap: 16px;
	}
}

.loading {
	opacity: 0.8;
}

.centralize {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.swap-item-btn-v {
	display: none;
}

@media (max-width: 730px) {
	.list-selection-wrapper {
		display: flex;
		flex: 1 1 0px;
		flex-direction: column;

		.list-box-wrapper {
			min-height: 46%;
		}

		&.hide-center {
			gap: 12px;
		}
	}

	.centralize {
		flex-direction: row;

		.selection-btn {
			transform: rotateZ(90deg);
		}
	}

	.swap-item-btn-v {
		display: block;
	}

	.swap-item-btn-h {
		display: none;
	}
}
</style>
